import { render, staticRenderFns } from "./DiscountEditor.vue?vue&type=template&id=6ccadfca"
import script from "./DiscountEditor.vue?vue&type=script&lang=js"
export * from "./DiscountEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports